var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#232A2E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.51,4.17v41.66c0,1.48-1.21,2.7-2.7,2.7H3.2c-1.49,0-2.71-1.22-2.71-2.71V4.18c0-1.5,1.21-2.71,2.71-2.71 h43.61C48.3,1.47,49.51,2.68,49.51,4.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.81,49.02H3.2c-1.76,0-3.2-1.43-3.2-3.2V4.18c0-1.76,1.43-3.2,3.2-3.2h43.61c1.76,0,3.19,1.43,3.19,3.19 v41.66C50,47.59,48.57,49.02,46.81,49.02z M3.2,1.96c-1.22,0-2.22,0.99-2.22,2.22v41.64c0,1.22,0.99,2.22,2.22,2.22h43.61 c1.22,0,2.21-0.99,2.21-2.21V4.17c0-1.22-0.99-2.21-2.21-2.21H3.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.57,5.81v38.39c0,0.77-0.62,1.39-1.39,1.39H4.83c-0.77,0-1.39-0.62-1.39-1.39V5.81 c0-0.77,0.62-1.39,1.39-1.39h40.35C45.94,4.41,46.57,5.04,46.57,5.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.18,46.08H4.83c-1.04,0-1.88-0.84-1.88-1.88V5.81c0-1.04,0.85-1.88,1.88-1.88h40.35 c1.04,0,1.88,0.85,1.88,1.88v38.39C47.06,45.23,46.21,46.08,45.18,46.08z M4.83,4.9c-0.5,0-0.9,0.41-0.9,0.9v38.39 c0,0.5,0.41,0.9,0.9,0.9h40.35c0.5,0,0.9-0.4,0.9-0.9V5.81c0-0.5-0.4-0.9-0.9-0.9H4.83z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000013895778565907863290000000780995682698864260_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.9,11.78l-2.26-2.31c-0.15-0.16-0.42-0.16-0.57,0l-2.26,2.31c-0.15,0.15-0.15,0.4,0,0.56l2.26,2.3 c0.08,0.08,0.18,0.12,0.29,0.12c0.11,0,0.21-0.04,0.29-0.12l2.26-2.3C28.05,12.18,28.05,11.93,27.9,11.78z M25.36,13.79 l-1.7-1.73l1.7-1.74l1.7,1.74L25.36,13.79z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000159459453941516927110000003393113195253254844_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.9,24.99l-2.26-2.31c-0.15-0.15-0.42-0.15-0.57,0l-2.26,2.31c-0.15,0.15-0.15,0.4,0,0.56l2.26,2.31 c0.08,0.07,0.18,0.12,0.29,0.12c0.11,0,0.21-0.05,0.29-0.12l2.26-2.31C28.05,25.38,28.05,25.14,27.9,24.99z M25.36,27l-1.7-1.73 l1.7-1.74l1.7,1.74L25.36,27z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000123411712072876914020000017442621651547322498_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.24,18.37l-2.27-2.23c-0.15-0.15-0.41-0.15-0.56,0l-2.27,2.23c-0.07,0.07-0.12,0.17-0.12,0.28 c0,0.11,0.05,0.21,0.12,0.29l2.27,2.23c0.08,0.08,0.17,0.12,0.28,0.12c0.1,0,0.2-0.04,0.28-0.12l2.27-2.23 c0.07-0.08,0.12-0.17,0.12-0.29C38.36,18.55,38.31,18.45,38.24,18.37z M35.68,20.33l-1.7-1.67l1.7-1.67l1.7,1.67L35.68,20.33z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000122703268564592015730000003953505509922836128_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.62,18.38l-2.31-2.27c-0.15-0.15-0.4-0.15-0.56,0l-2.31,2.27c-0.08,0.07-0.12,0.17-0.12,0.28 c0,0.11,0.04,0.21,0.12,0.29l2.31,2.27c0.08,0.07,0.18,0.11,0.28,0.11c0.1,0,0.21-0.04,0.28-0.11l2.31-2.27 c0.08-0.08,0.12-0.17,0.12-0.29C17.74,18.55,17.7,18.45,17.62,18.38z M15.03,20.37l-1.75-1.72l1.75-1.71l1.75,1.71L15.03,20.37z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000036955182857972545450000015319817116069315489_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.41,6.99c0.08,0.08,0.18,0.11,0.28,0.11s0.2-0.04,0.28-0.11l1.75-1.71c0.16-0.15,0.16-0.41,0.01-0.56 c-0.15-0.16-0.41-0.16-0.56-0.01l-1.47,1.44l-1.47-1.44c-0.16-0.15-0.41-0.15-0.56,0c-0.15,0.16-0.15,0.41,0.01,0.56L35.41,6.99z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000149372906979194338340000012565106336687757463_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.75,6.99c0.08,0.08,0.18,0.11,0.28,0.11s0.2-0.04,0.28-0.11l1.75-1.71c0.16-0.15,0.16-0.41,0.01-0.56 c-0.15-0.16-0.41-0.16-0.56,0l-1.47,1.44l-1.47-1.44C13.4,4.55,13.15,4.56,13,4.71C12.85,4.87,12.85,5.12,13,5.28L14.75,6.99z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000018952012183358717970000018124034230248275618_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.9,38.19l-2.26-2.31c-0.15-0.15-0.42-0.15-0.57,0l-2.26,2.31c-0.15,0.16-0.15,0.41,0,0.56l2.26,2.31 c0.08,0.08,0.18,0.12,0.29,0.12c0.11,0,0.21-0.04,0.29-0.12l2.26-2.31C28.05,38.6,28.05,38.35,27.9,38.19z M25.36,40.21 l-1.7-1.74l1.7-1.73l1.7,1.73L25.36,40.21z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000144329184075250957110000005364363308532861859_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.24,31.58l-2.27-2.23c-0.15-0.15-0.41-0.16-0.56,0l-2.27,2.23c-0.07,0.07-0.12,0.17-0.12,0.29 c0,0.1,0.05,0.21,0.12,0.28l2.27,2.23c0.08,0.08,0.17,0.12,0.28,0.12c0.1,0,0.2-0.04,0.28-0.11l2.27-2.23 c0.07-0.07,0.12-0.17,0.12-0.28C38.36,31.76,38.31,31.66,38.24,31.58z M35.68,33.54l-1.7-1.67l1.7-1.68l1.7,1.68L35.68,33.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000005245186763290524970000006236166086970680480_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "37.39,31.87 35.68,33.54 33.98,31.87 35.68,30.19  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000106139713645128201180000000619763458795616441_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.62,31.58l-2.31-2.27c-0.15-0.15-0.4-0.15-0.56,0l-2.31,2.27c-0.08,0.07-0.12,0.17-0.12,0.29 c0,0.1,0.04,0.21,0.12,0.28l2.31,2.27c0.08,0.08,0.18,0.11,0.28,0.11c0.1,0,0.21-0.03,0.28-0.11l2.31-2.27 c0.08-0.07,0.12-0.17,0.12-0.28C17.74,31.76,17.7,31.66,17.62,31.58z M15.03,33.58l-1.75-1.71l1.75-1.72l1.75,1.72L15.03,33.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000026850324257718583110000014027275343975628735_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.96,43.72c-0.15-0.15-0.4-0.15-0.56,0l-1.75,1.72c-0.16,0.15-0.16,0.41-0.01,0.56 c0.15,0.16,0.41,0.16,0.56,0l1.47-1.44L37.15,46c0.08,0.08,0.18,0.11,0.28,0.11c0.1,0,0.21-0.04,0.28-0.12 c0.15-0.16,0.15-0.41-0.01-0.56L35.96,43.72z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000085959895162218669480000009451954344740105110_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.31,43.72c-0.15-0.15-0.4-0.15-0.56,0L13,45.43c-0.16,0.15-0.16,0.41-0.01,0.56 c0.08,0.08,0.18,0.12,0.28,0.12c0.1,0,0.2-0.04,0.28-0.11l1.47-1.44L16.5,46c0.16,0.15,0.41,0.15,0.56,0 c0.15-0.16,0.15-0.41-0.01-0.56L15.31,43.72z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000106142889857774554810000001066966851561227182_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.18,31.29L40.01,25l6.17-6.29c0.02-0.02,0.32-0.28,0-0.55l-6.17-6.29l6.17-6.29 c0.11-0.11,0.14-0.28,0.08-0.43C46.2,5,46.06,4.9,45.9,4.9h-3.83c-0.11,0-0.21,0.04-0.29,0.12l-6.16,6.28l-6.16-6.28 c-0.08-0.08-0.17-0.12-0.28-0.12h-7.65c-0.11,0-0.21,0.04-0.29,0.12l-6.16,6.28L8.93,5.02C8.86,4.94,8.75,4.9,8.64,4.9H4.82 C4.66,4.9,4.52,5,4.45,5.15C4.39,5.29,4.42,5.46,4.54,5.57l6.17,6.29l-6.17,6.29c-0.29,0.27-0.02,0.54,0,0.55L10.71,25 l-6.17,6.29c-0.02,0.02-0.28,0.32,0,0.56l6.17,6.29l-6.17,6.29c-0.12,0.11-0.15,0.28-0.09,0.43C4.52,45,4.66,45.1,4.82,45.1h3.83 c0.11,0,0.21-0.04,0.28-0.12l6.16-6.28l6.16,6.28c0.08,0.08,0.18,0.12,0.29,0.12h7.65c0.11,0,0.21-0.04,0.29-0.12l6.16-6.28 l6.16,6.28c0.07,0.08,0.18,0.12,0.28,0.12h3.83c0.16,0,0.3-0.09,0.36-0.25c0.06-0.14,0.03-0.32-0.08-0.43l-6.17-6.29l6.17-6.29 C46.2,31.82,46.44,31.54,46.18,31.29z M39.35,24.51h-2.77l5.77-5.88h2.77L39.35,24.51z M42.35,5.88h2.77l-5.77,5.88h-2.77 L42.35,5.88z M39.35,12.75l5.78,5.88h-2.77l-5.78-5.88H39.35z M41.61,18.66l-5.92,6.03l-5.92-6.03l5.92-6.03L41.61,18.66z  M21.69,31.37l-5.77-5.88h2.77l5.77,5.88H21.69z M24.47,32.35l-5.78,5.88h-2.77l5.78-5.88H24.47z M15.92,24.51l5.77-5.88h2.77 l-5.77,5.88H15.92z M19.43,25.26l5.92-6.03l5.92,6.03l-5.92,6.03L19.43,25.26z M32.02,25.49h2.77l-5.77,5.88h-2.77L32.02,25.49z  M32.02,24.51l-5.77-5.88h2.77l5.77,5.88H32.02z M26.25,18.63l5.78-5.88h2.77l-5.78,5.88H26.25z M29.02,5.88l5.77,5.88h-2.77 l-5.77-5.88H29.02z M31.28,12.06l-5.92,6.03l-5.92-6.03l5.92-6.04L31.28,12.06z M21.69,5.88h2.77l-5.77,5.88h-2.77L21.69,5.88z  M18.69,12.75l5.78,5.88H21.7l-5.78-5.88H18.69z M20.95,18.66l-5.92,6.03l-5.92-6.03l5.92-6.03L20.95,18.66z M5.6,5.88h2.77 l5.77,5.88h-2.77L5.6,5.88z M11.37,12.75h2.77l-5.78,5.88H5.59L11.37,12.75z M5.6,18.63h2.77l5.77,5.88h-2.77L5.6,18.63z  M11.37,25.49h2.77l-5.77,5.88H5.6L11.37,25.49z M8.36,45.1H5.6l5.77-5.88h2.77L8.36,45.1z M11.37,38.24l-5.78-5.88h2.77 l5.78,5.88H11.37z M9.11,31.87l5.92-6.04l5.92,6.04l-5.92,6.03L9.11,31.87z M21.69,45.1l-5.77-5.88h2.77l5.77,5.88H21.69z  M19.43,38.47l5.92-6.03l5.92,6.03l-5.92,6.04L19.43,38.47z M29.02,45.1h-2.77l5.77-5.88h2.77L29.02,45.1z M32.02,38.24 l-5.78-5.88h2.77l5.78,5.88H32.02z M29.76,31.87l5.92-6.04l5.92,6.04l-5.92,6.03L29.76,31.87z M45.12,45.1h-2.77l-5.77-5.88h2.77 L45.12,45.1z M39.35,38.24h-2.77l5.78-5.88h2.77L39.35,38.24z M42.35,31.37l-5.77-5.88h2.77l5.77,5.88H42.35z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000096739019865480635670000013467092691820704937_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "27.06,38.47 25.36,40.21 23.66,38.47 25.36,36.74  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000116930004650689235450000009668575495102277042_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.46,45.91l-2.15-2.2c-0.15-0.15-0.42-0.15-0.57,0l-2.15,2.2H17.46z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000019679575088817629500000007153412085624772502_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.12,45.91l-2.15-2.2c-0.15-0.15-0.42-0.15-0.57,0l-2.15,2.2H38.12z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000163058597390974034660000011856174002147435927_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.25,4.69l2.15,2.2c0.15,0.15,0.42,0.15,0.57,0l2.15-2.2L33.25,4.69z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000168105753388222887120000012381084145701514886_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.59,4.69l2.15,2.2c0.15,0.15,0.42,0.15,0.57,0l2.15-2.2L12.59,4.69z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000081622249430032223400000003717340185340496270_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "27.06,25.26 25.36,27 23.66,25.26 25.36,23.52  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000145752810302072331600000005627244402264300945_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "16.78,31.87 15.03,33.58 13.28,31.87 15.03,30.15  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000020366578918272900970000000765435270175369352_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "16.78,18.66 15.03,20.37 13.28,18.66 15.03,16.95  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000101092451396809123810000001237374226861671814_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "27.06,12.06 25.36,13.79 23.66,12.06 25.36,10.32  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000082361076401672661170000011290677517402229434_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "37.39,18.66 35.68,20.33 33.98,18.66 35.68,16.99  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000039123609905493017030000006531310940394552764_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "14.13,39.22 8.36,45.1 5.6,45.1 11.37,39.22  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000057833238519465741320000009155818881844139155_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "14.14,38.24 11.37,38.24 5.59,32.35 8.36,32.35  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000050656727583058475090000012657921562944266393_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "14.13,25.49 8.36,31.37 5.6,31.37 11.37,25.49  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000081638147536991116240000012028048869387791539_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "14.13,24.51 11.37,24.51 5.6,18.63 8.36,18.63  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000076573457388526218780000001312421794120533433_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "14.14,12.75 8.36,18.63 5.59,18.63 11.37,12.75  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000058568083560113442590000002930940493126051722_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "14.13,11.76 11.37,11.76 5.6,5.88 8.36,5.88  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000080901525555214337630000003853844657161617586_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "24.46,5.88 18.69,11.76 15.92,11.76 21.69,5.88  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000056421601478502536780000011430512936765513625_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "24.47,18.63 21.7,18.63 15.92,12.75 18.69,12.75  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000168836863491221164500000011062962871590751894_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "24.46,18.63 18.69,24.51 15.92,24.51 21.69,18.63  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000130623841549098561420000017559346768197599622_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "24.46,31.37 21.69,31.37 15.92,25.49 18.69,25.49  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000093891000223378262860000008286863961901724577_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "24.47,32.35 18.69,38.24 15.92,38.24 21.7,32.35  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000173143599920336556090000014293252660264785559_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "24.46,45.1 21.69,45.1 15.92,39.22 18.69,39.22  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000127722231302479718330000007928679116394131074_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "45.12,45.1 42.35,45.1 36.58,39.22 39.35,39.22  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000082356550132269334700000013639227216442235832_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "45.12,32.35 39.35,38.24 36.57,38.24 42.35,32.35  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000143579470034826712140000009731864200860470975_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "45.12,31.37 42.35,31.37 36.58,25.49 39.35,25.49  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000057140900857979266260000007785619013376618392_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "45.12,18.63 39.35,24.51 36.58,24.51 42.35,18.63  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000095328573667532568170000005163834482168094860_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "45.12,18.63 42.35,18.63 36.57,12.75 39.35,12.75  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000103954129836244886580000004237244416397635218_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "45.12,5.88 39.35,11.76 36.58,11.76 42.35,5.88  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000168812754183544187190000005503837873458704568_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "34.79,11.76 32.02,11.76 26.25,5.88 29.02,5.88  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000101088616080212500220000009478671623595149205_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "34.8,12.75 29.02,18.63 26.25,18.63 32.02,12.75  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000140700598075344214180000015441739347505835178_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "34.79,24.51 32.02,24.51 26.25,18.63 29.02,18.63  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000055696081416477307640000007628872783678508705_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "34.79,25.49 29.02,31.37 26.25,31.37 32.02,25.49  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000014603108602709525840000007150522404689470883_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "34.8,38.24 32.02,38.24 26.25,32.35 29.02,32.35  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000179634973044995202520000009585399116716498574_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "34.79,39.22 29.02,45.1 26.25,45.1 32.02,39.22  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000123420490556254364380000012792062913832002473_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.64,14.67l2.2-2.15c0.15-0.15,0.15-0.42,0-0.57L3.64,9.8L3.64,14.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000019670724200402865960000006883973025399374471_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.64,27.7l2.2-2.15c0.15-0.15,0.15-0.42,0-0.57l-2.2-2.15L3.64,27.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000141441023148849742370000007160782062496866207_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.64,40.67l2.2-2.15c0.15-0.15,0.15-0.42,0-0.57l-2.2-2.15L3.64,40.67z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000079464525484356190170000001070397123625058747_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.83,14.67l-2.2-2.15c-0.15-0.15-0.15-0.42,0-0.57l2.2-2.15V14.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000180332091068454131300000015474709954783503027_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.83,27.7l-2.2-2.15c-0.15-0.15-0.15-0.42,0-0.57l2.2-2.15V27.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000007395896305794618280000001717435014273578423_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.83,40.67l-2.2-2.15c-0.15-0.15-0.15-0.42,0-0.57l2.2-2.15V40.67z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiling);
export default __webpack_public_path__ + "static/media/tiling.f8f61c9895625ef3a2cfce574904f6e3.svg";
export { ForwardRef as ReactComponent };